import React from 'react';
import { X } from 'lucide-react';

const PLATFORMS = [
  { key: 'pc', label: 'PC' },
  { key: 'console', label: 'Console' },
];

export default function ShopFilters({ filters, onChange, brands, priceBounds }) {
  const set = (patch) => onChange({ ...filters, ...patch });

  const togglePlatform = (key) => {
    const has = filters.platforms.includes(key);
    set({ platforms: has ? filters.platforms.filter((p) => p !== key) : [...filters.platforms, key] });
  };

  const clearAll = () => onChange({ brand: 'all', platforms: [], inStockOnly: false, minPrice: '', maxPrice: '' });

  return (
    <div className="space-y-5">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {/* Price */}
        <div>
          <p className="text-white/40 text-[10px] font-bold tracking-widest mb-2">PRICE (£)</p>
          <div className="flex items-center gap-2">
            <input type="number" min="0" value={filters.minPrice} onChange={(e) => set({ minPrice: e.target.value })} placeholder="Min"
              className="w-full bg-[#0d0d0f] border border-white/10 text-white text-sm h-9 px-2 placeholder:text-white/20 focus:border-primary/60 focus:outline-none" />
            <span className="text-white/30 text-xs">–</span>
            <input type="number" min="0" value={filters.maxPrice} onChange={(e) => set({ maxPrice: e.target.value })} placeholder="Max"
              className="w-full bg-[#0d0d0f] border border-white/10 text-white text-sm h-9 px-2 placeholder:text-white/20 focus:border-primary/60 focus:outline-none" />
          </div>
          {priceBounds && (
            <p className="text-white/20 text-[10px] mt-1">{priceBounds.min.toFixed(0)} – {priceBounds.max.toFixed(0)}</p>
          )}
        </div>

        {/* Platform */}
        <div>
          <p className="text-white/40 text-[10px] font-bold tracking-widest mb-2">PLATFORM</p>
          <div className="flex gap-2">
            {PLATFORMS.map((p) => {
              const on = filters.platforms.includes(p.key);
              return (
                <button key={p.key} onClick={() => togglePlatform(p.key)}
                  className={`text-xs font-bold tracking-wider px-3 py-2 border transition-colors ${on ? 'border-primary text-primary bg-primary/10' : 'border-white/10 text-white/50 hover:text-white'}`}>
                  {p.label}
                </button>
              );
            })}
          </div>
        </div>

        {/* Brand */}
        <div>
          <p className="text-white/40 text-[10px] font-bold tracking-widest mb-2">BRAND</p>
          <select value={filters.brand} onChange={(e) => set({ brand: e.target.value })}
            className="w-full bg-[#0d0d0f] border border-white/10 text-white text-sm h-9 px-2 focus:border-primary/60 focus:outline-none">
            <option value="all" className="bg-[#0d0d0f]">All brands</option>
            {brands.map((b) => <option key={b} value={b} className="bg-[#0d0d0f]">{b}</option>)}
          </select>
        </div>

        {/* Availability */}
        <div>
          <p className="text-white/40 text-[10px] font-bold tracking-widest mb-2">AVAILABILITY</p>
          <label className="flex items-center gap-2.5 cursor-pointer h-9">
            <input type="checkbox" checked={filters.inStockOnly} onChange={(e) => set({ inStockOnly: e.target.checked })} className="w-4 h-4 accent-primary" />
            <span className="text-white/70 text-sm">In stock only</span>
          </label>
        </div>
      </div>

      <div className="flex justify-end">
        <button onClick={clearAll} className="inline-flex items-center gap-1.5 text-xs font-bold tracking-wider text-white/40 hover:text-white border border-white/10 hover:border-white/25 px-3 py-1.5 transition-colors">
          <X className="w-3.5 h-3.5" /> CLEAR FILTERS
        </button>
      </div>
    </div>
  );
}